import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SendPaymentInstructionModelService {
  sendPaymentStep = {
    paymentInfo: 'paymentInfo',
    paymentConfirmation: 'paymentConfirmation',
    balanceTradeAvailable: 'balanceTradeAvailable',
    paymentComplete: 'paymentComplete',
    paymentMandate: 'paymentMandate',
    drawdownSummary: 'drawdownSummary',
    validatePayment: 'validatePayment'
  };

  sendPaymentType: Number;
  twillioActionId = '';
  paymentId = '';
  paymentReference = '';
  purposePaymentIdSelected = null;

  selectedRecipient = {
    name: '',
    id: '',
    currencyId: '',
    saveForFuture: true,
    bank: {
      countryId: '',
      purposeOfPaymentId: ''
    }
  };

  newRecipient = {
    name: '',
    id: '',
    currencyId: '',
    saveForFuture: false,
    bank: {
      countryId: '',
      purposeOfPaymentId: ''
    }
  };

  ultimateRemitterId = '';

  currency = {
    code: '',
    id: ''
  };
  reasonPayment = {
    name: '',
    id: ''
  };
  reasonPaymentOther: any;
  amount: any;
  paymentDate: Date;

  // Add or update
  manageRecipientFromPayment = null;
  recipientMandate = null;
  processWithMandate = false;
  tradeDrawdown = [];
  tradeFundPayment = [];
  step = '';
  tradeId: string;
  tradeList = [];
  availableBalance: any;
  tradeValueDate: Date;
  externalPaymentId: string;

  clearData() {
    this.tradeDrawdown = [];
    this.tradeFundPayment = [];
    this.purposePaymentIdSelected = null;
    this.paymentReference = '';
    this.recipientMandate = null;
    this.processWithMandate = false;
    this.manageRecipientFromPayment = false;
    this.tradeId = '';
    this.externalPaymentId = '';
  }

  clearDataAfterFunAccount() {
    this.selectedRecipient = {
      name: '',
      id: '',
      currencyId: '',
      saveForFuture: true,
      bank: {
        countryId: '',
        purposeOfPaymentId: ''
      }
    };

    this.newRecipient = {
      name: '',
      id: '',
      currencyId: '',
      saveForFuture: false,
      bank: {
        countryId: '',
        purposeOfPaymentId: ''
      }
    };

    this.reasonPayment = {
      name: '',
      id: ''
    };

    this.ultimateRemitterId = '';
  }
}
